export const namespaces = {
  common: "common",
  aria: "aria",
  validation: "validation",
  routes: "routes",
  mainPage: "mainPage",
  auth: "auth",
  modals: "modals",
  userAdminPanel: "userAdminPanel"
};

export const languages = {
  uk: "UK",
  en: "EN",
  pl: "PL"
};

